import React from 'react'
import { apiFetch } from '../../../fetchApi';

export const updateExperience = ({ BeURL, id, experience, candidateId, showAlert }) => {
    apiFetch(`${BeURL}/candidate-experience/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ experience, candidateId }),
    })
        .then((res) => res.json())
        .then((data) => {
            console.log("Response Data:", data);
            if (data.success) {
                showAlert(data.message);
                setTimeout(()=>{
                    window.location.reload()
                }, [1000])
            } else {
                showAlert("Failed to update Experience: " + (data.message || "Unknown error"));
            }
        })
        .catch((err) => {
            console.log("Error in updating Experience", err);
        });
}
